/* eslint-disable no-unused-vars */
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Reusable Components
import SubTitleContents from "reusables/TextFormats/SubTitleContents";
import TransparentBlogCard from "reusables/Cards/BlogCards/TransparentBlogCard";

// Images
import full1 from "assets/images/Services/Full/full1.jpg";
import full2 from "assets/images/Services/Full/full2.jpg";
import full3 from "assets/images/Services/Full/full3.jpg";
import full4 from "assets/images/Services/Full/full4.jpg";
import full5 from "assets/images/Services/Full/full5.jpg";
import full6 from "assets/images/Services/Full/full6.jpg";
import full7 from "assets/images/Services/Full/full7.jpg";
import full8 from "assets/images/Services/Full/full8.jpg";
import full9 from "assets/images/Services/Full/full9.jpg";
import full10 from "assets/images/Services/Full/full10.jpg";

function Full_Section1() {
  return (
    <Container>
      <SubTitleContents
        title="Why Choose Our Full Property Management?"
        contents="For landlords looking for a stress-free experience, our Full Property Management Service covers all aspects of managing your property. From tenant placement to ongoing maintenance, we handle everything on your behalf."
      />
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6} lg={4} textAlign="justify" wordbreak="break-all">
          <TransparentBlogCard image={full1} />
        </Grid>
        <Grid item xs={12} sm={6} lg={4} textAlign="justify" wordbreak="break-all">
          <TransparentBlogCard image={full2} />
        </Grid>
        <Grid item xs={12} sm={6} lg={4} textAlign="justify" wordbreak="break-all">
          <TransparentBlogCard image={full10} />
        </Grid>
      </Grid>
    </Container>
  );
}

export default Full_Section1;
